import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MagasindetailService {
  uri = localStorage.getItem('serverRoot');
  user = JSON.parse(sessionStorage.getItem('user'));

  constructor(private http: HttpClient) {
  }

  addEntree(quantityField, productField, warehouseField) {
    const magasin = {
      warehouse: warehouseField,
      product: productField,
      quantity: quantityField
    };
    return this.http.post(`${this.uri}/admins/${this.user._id}/addEntree`, magasin);
  }

  getWarehouseById(id) {
    return this.http.get(`${this.uri}/admins/${this.user._id}/warehouse/${id}`);
  }

  getWarehouses() {
    return this.http.get(`${this.uri}/admins/${this.user._id}/warehouses`);
  }

  getCompanys() {
    return this.http.get(`${this.uri}/admins/${this.user._id}/companys`);
  }
}
